module.exports = __webpack_public_path__ + "94395c2bdffaf88caf6bece2d826742f.png";